import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import jsPDF from 'jspdf';
import rasterizeHTML from 'rasterizehtml';
import SuccessTabs from './SuccessTabs/SuccessTabs';
import html2canvas from 'html2canvas';

class ChallengeStatementSuccess extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            pdfDownload: false,
        };
    }
    printDocument = (e) => {
        e.preventDefault();
        const canvas = document.createElement('canvas');
        canvas.height = 1000;
        canvas.width = 1500;
        // canvas.textAlign = "center";

        let html = `<div style='width:"930px";padding: 20px 0px 0px 30px'>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>

                        <br/>
            ${this.props.benefits.benefitsLadderData.Items[0].data.map(item => {
                return `<div style="margin-bottom: 20px">
                    <div>
                        <div style='width: fit-content;    padding: 10px; margin-bottom: 15px; background: #f2f2f2;margin-left: 10px;border: none'>
                            <span style="font-weight: bold; color: #000;border: none">${item.groupName}</span>
                        </div>
                    </div>
                    <div style="width: 700px">
                        <table style="width: 100%" border="1" cellspacing="0" cellpadding="15">
                            <tbody>
                                <tr>
                                    <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">Values</td>
                                    <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">
                                        ${item.values.length > 0 ? item.values.map(value => {
                        return  `<p>${value.name}</p>`
                    }).join('') : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">Benefits</td>
                                    <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">
                                    ${item.benefits.length > 0 ? item.benefits.map(value => {
                        return`<p>${value.name}</p>`
                    }).join('') : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">Attributes</td>
                                    <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">
                                    ${item.attributes.length > 0 ? item.attributes.map(value => {
                        return `<p>${value.name}</p>`
                    }).join('') : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>`
            }).join('')}
            </div>`;
        rasterizeHTML.drawHTML(html, canvas).then((renderResult) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');
            pdf.addImage(imgData, 'JPEG', 0, 0);
            pdf.save('benefits_Ladder.pdf');
        });
    }
    printPage = () => {
        let html = `<div style='width:"930px";padding: 20px 0px 0px 30px'>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>

                        <br/>
            ${this.props.benefits.benefitsLadderData.Items[0].data.map(item => {
                return `<div style="margin-bottom: 20px">
                    <div>
                        <div style='width: fit-content;    padding: 10px; margin-bottom: 15px; background: #f2f2f2;margin-left: 10px;'>
                            <a style="font-weight: bold; text-shadow: 0px 0px 3px #ddd; color: #000">${item.groupName}</a>
                        </div>
                    </div>
                    <div style="width: 700px">
                        <table style="width: 100%" border="1" cellspacing="0" cellpadding="15">
                            <tbody>
                                <tr>
                                    <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">Values</td>
                                    <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">
                                        ${item.values.length > 0 ? item.values.map(value => {
                        return `<p>${value.name}</p>`
                    }).join('') : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">Benefits</td>
                                    <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">
                                    ${item.benefits.length > 0 ? item.benefits.map(value => {
                        return`<p>${value.name}</p>`
                    }).join('') : ''}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">Attributes</td>
                                    <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">
                                    ${item.attributes.length > 0 ? item.attributes.map(value => {
                        return `<p>${value.name}</p>`
                    }).join('') : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>`
            }).join('')}
            </div>`;
        let w = window.open();
        w.document.write(html);
        w.print();
        w.close();
    };
    downloadPDF = (e) => {
        this.printDocument(e);
    }
    elementInfiniteLoad() {
        return (
          <div className='col-sm-12'>
            <div className='spinner3'>
              <div className='rect1' />
              <div className='rect2' />
              <div className='rect3' />
              <div className='rect4' />
              <div className='rect5' />
            </div>
          </div>
        );
      }
    render() {
        return (
            <div className='projects-content challenge-statement-content'>
                <div className='step-bar'>
                    <div className='step step-two arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-two arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>BENEFITS LADDER</h5>
                      </div>
                    </div>
                    <div className='row' >
                        {(this.props.benefits.editGroupFetching || this.props.benefits.benefitsLadderFetching) &&
                            <div className="col-md-12">
                                {this.elementInfiniteLoad()}
                            </div>
                        }
                        <SuccessTabs
                            benefits={this.props.benefits}
                            tabStep={this.props.tabStep}
                            onTabChange={this.props.onTabChange}
                        />
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <Link className='btn btn-success' to={'/segmentation/'+this.props.projectId}> Next </Link>
                                    <Link className='btn btn-success' to='/toolkit'> Done </Link>
                                    <div className='btn empty-btn default' onClick={this.printPage}>Print</div>
                                    <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>
                                    <div className='btn empty-btn default' onClick={this.props.goBack}>Back</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (ChallengeStatementSuccess);



// WEBPACK FOOTER //
// ./src/components/BenefitsLadder/BenefitsLadderSuccess/BenefitsLadderSuccess.jsx